import { Card } from 'primereact/card';
import React, {  } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import userImage from '../../../assets/images/UserImage.png';
import { InputText } from 'primereact/inputtext';

export default function GraceMarksCard(props) {

    const subjectList = props?.student?.SubjectList || [];

    const handleMarksChange = (e, index, subject) => {
        props.onMarkeChange(props.student.StudentId, index, subject, e.value);

    };
    const marksEditor = (rowData, { rowIndex }) => {
        return (
            <InputText
                value={rowData?.GraceMark}
                onChange={(e) => handleMarksChange(e, rowIndex, rowData?.SubjectId)}
                style={{ width: "60px", textAlign: "center" }}
            />
        );
    };

    return (
        <div className="p-4">
            <div className="flex items-center gap-4 p-4 border-b mb-4">
                <img src={props?.student?.ProfilePic || userImage} alt="" className="upload-preview" style={{ width: '100px', height: '100px', borderRadius: '8px', objectFit: 'cover' }} />
                <div>
                    <h3 className="text-lg font-semibold">{props?.student?.StudentName || "Unknown Student"}</h3>
                    <p className="text-gray-500">Roll No: {props?.student?.RollNo || "N/A"}</p>
                </div>
            </div>
            <hr className='p-m-0' />
            <Card className="mb-4">
                <DataTable value={subjectList} responsiveLayout="scroll">
                    <Column header="Sr No." body={(rowData, { rowIndex }) => rowIndex + 1} />
                    <Column field="SubjectName" header="Subject Name" />
                    <Column field="ExamTypeName" header="Exam Type" />
                    <Column field="MarksGiven" header="Marks Given" />
                    <Column field="MarksRequired" header="Required Marks" />
                    <Column body={marksEditor} header="Grace Mark" />
                </DataTable>
            </Card>

        </div>
    );
}
